export class DatabaseUserAttribute {
    id = 0;
    key = "";
    value = "";
}
